import React from 'react'
import {
    CardEvents,
    CollectionEvent,
    PublicationCardItem,
    createCardClickedEvent,
    toLinkWithHint,
    useFeature,
} from '@news-mono/web-common'
import { MaybeLoaded } from 'json-react-layouts-data-loader'
import { invertMaybeLoadedItems } from '../../../collections/helpers/loading'
import { getFundingType } from '../../../templates'
import { cx } from '@emotion/css'
import {
    StyledInlineContentCardsContainer,
    StyledLinkWrapper,
} from './InlineContentCards.styled'
import { ThemeOverrider } from '../../../themes/ThemeOverrider/ThemeOverrider'
import { getBauhausThemeOverride } from '../../../__styling/get-bauhaus-theme-override'
import { InlineContentCard } from '../../cards/InlineContentCard'

interface InlineRelatedContentCardsProps {
    items: MaybeLoaded<PublicationCardItem[]>
    expectedCards: number
    onEvent: (event: CardEvents | CollectionEvent) => void
}

export const InlineRelatedContentCards: React.FC<InlineRelatedContentCardsProps> =
    (props) => {
        const items = invertMaybeLoadedItems(props.items, props.expectedCards)

        const storyClassification = useFeature('story-classification')

        function linkClicked(
            e: React.MouseEvent<HTMLElement>,
            item: MaybeLoaded<PublicationCardItem>,
            cardNumber: number,
        ) {
            if (!item.loaded) {
                e.preventDefault()
                return
            }
            props.onEvent(
                createCardClickedEvent(
                    props.onEvent,
                    item.result,
                    'SevenNewsInlineRelatedContentCard',
                    'InlineRelatedContent',
                    cardNumber,
                    getFundingType(item.result, storyClassification),
                    'InlineRelatedCollection',
                ),
            )
        }

        return (
            <StyledInlineContentCardsContainer className={cx('hide-print')}>
                {items.map((item, index) => {
                    const key = (item.loaded && item.result.id) || index

                    if (item.loaded) {
                        const themeOverride = getBauhausThemeOverride(
                            item.result.link,
                        )

                        return (
                            <ThemeOverrider override={themeOverride} key={key}>
                                <StyledLinkWrapper
                                    to={toLinkWithHint(item)}
                                    onClick={(event) => {
                                        linkClicked(event, item, index)
                                    }}
                                >
                                    <InlineContentCard item={item} />
                                </StyledLinkWrapper>
                            </ThemeOverrider>
                        )
                    }
                })}
            </StyledInlineContentCardsContainer>
        )
    }
